export const deviceUtils = {
	isMobile() {
		return window.innerWidth < 480;
	},

	isTablet() {
		return window.innerWidth < 768;
	},

	isLaptop() {
		return window.innerWidth < 1024;
	},

	isTouchDevice() {
		return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	},

	isTouchMode() {
		return this.isTouchDevice() || this.isLaptop();
	},
};
